exports.safeDivide = (numerator, denominator) => (denominator > 0 ? numerator / denominator : 0);

exports.insertBeforeItem = (array, searchFor, inserted) => {
    const idx = array.indexOf(searchFor);
    // if array already includes what we want to insert we return the array.
    if (array.includes(inserted)) {
        return array;
    }
    if (idx === -1) {
        array.push(inserted);
    } else {
        array.splice(idx, 0, inserted);
    }
    return array;
};

exports.insertAfterItem = (array, searchFor, inserted) => {
    const idx = array.indexOf(searchFor);
    // if array already includes what we want to insert we return the array.
    if (array.includes(inserted)) {
        return array;
    }
    if (idx === -1) {
        array.push(inserted);
    } else {
        array.splice(idx + 1, 0, inserted);
    }
    return array;
};

exports.escapeSalesforceSoslSpecialCharacters = (text) => {
    let escapedText = text;
    // match special characters to remove. most of these break the query, some enhance
    // Read more about SOSL syntax and reserved chars.
    // https://developer.salesforce.com/docs/atlas.en-us.soql_sosl.meta/soql_sosl/sforce_api_calls_sosl_find.htm
    const charsToAvoid = [
        '?', '&', '|', '!', '{', '}', '[', ']',
        // '(', ')', // allows logical grouping logic e.g. (Sea) OR (Season)
        '^', '~',
        // '*', // allows wildcard search
        ':',
        // '"', // allows mandatory inclusion
        '+', '-'
    ];
    for (let i = 0; i < text.length; i += 1) {
        const aChar = text[i];
        if (charsToAvoid.includes(aChar)) {
            escapedText = escapedText.replace(aChar, '');
        }
    }
    return escapedText;
};

exports.findIndexofAttribute = (array, attr, value) => {
    for (let i = 0; i < array.length; i += 1) {
        if (array[i][attr] === value) {
            return i;
        }
    }
    return -1;
};



// WEBPACK FOOTER //
// ./src/helpers/utilities.js